const { localStorage } = global;

const browserLang = window.navigator.language || window.navigator.browserLanguage;
const browserLangReal = browserLang.match(/\S*(?=-)/) ? browserLang.match(/\S*(?=-)/)[0] : browserLang;

let language = localStorage ? localStorage.getItem('userLang') : '';
if (!language) language = (browserLangReal === 'zh' ? 'zh-CN' : 'en');

export default {
  language
};
